import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Button from '../../components/button/Button';
import './style/detect.scss';
import NoState from './components/no-state';
import GeoBroadcastCard from './components/geo-broadcast-card';
import Toast from '../../components/toast/Toast';
import BroadcastDetail from './components/broadcast-detail';
import BaseModal from '../../components/modal/BaseModal';
import ProgressText from '../../components/progress-text/Progress';
import handReaderImg from '../../assets/imgs/icon-read-hand.png';
import nativeInterface from '../../native-interact/native';
import RFIDInstance from '../../native-interact/RFID';
import { broadcastStore } from '../../mobx/stores/broadcast';

let tempMac = '';
let interrupt = false;

const process = [
  {
    name: '请放置读卡器',
    abort: '1',
    execute: () => {
      return RFIDInstance.readSerialNo(true).then((data) => {
        tempMac = data;
      });
    },
  },
  {
    name: '密钥认证',
    abort: '1',
    execute: () => {
      return RFIDInstance.auth();
    },
  },
  {
    name: '获取地磁工作模式',
    abort: '1',
    execute: () => {
      return RFIDInstance.readGeoWorkMode(true).then((data) => {
        tempMac = tempMac.replace(/^\w{2}/, data.manufacturer);
        broadcastStore.push(tempMac);
      });
    },
  },
  {
    name: '开启蓝牙广播',
    abort: '1',
    execute: () => {
      return RFIDInstance.startBluetoothBroadcast(12 * 60 * 60).then(() => {
        broadcastStore.updateState(tempMac, 'success');
      }).catch(() => {
        broadcastStore.updateState(tempMac, 'error');
      });
    },
  },
];

const MacList = observer(function (props) {
  return props.data.length === 0 ? (
    <div className="put-reader-animation">
      <img className="put-reader" src={handReaderImg} alt=" put reader" />
    </div>
  ) : (
    props.data.map((item, index) => {
      const desc = `mac${index + 1}：${item.mac}`;
      return (
        <ProgressText
          key={item.mac}
          text={desc}
          success={desc}
          error={desc}
          status={item.status}
        />
      );
    })
  );
});

class Detect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetail: false,
      selected: null,
      broadcastModalVisible: false,
    };

    this.openBroadcast = this.openBroadcast.bind(this);
    this.closeBroadcast = this.closeBroadcast.bind(this);
    this.onBack = this.onBack.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleShowDetail = this.handleShowDetail.bind(this);
  }

  componentDidMount() {
    this.props.store.startMonitor();
  }

  componentWillUnmount() {
    this.props.store.stopMonitor();
    this.stopReadGeo();
  }

  onBack() {
    this.setState({
      showDetail: false,
    });
  }

  startReadGeo() {
    const that = this;
    interrupt = false;

    (function execute() {
      that.executeRead().then(() => {
        this.readTimer = setTimeout(() => {
          execute();
        }, 5000);
      }).catch((error) => {
        if (error instanceof Error && error.message === '主动中断操作') {
          return;
        }
        this.readTimer = setTimeout(() => {
          execute();
        }, 5000);
      });
    }());
  }

  stopReadGeo() {
    clearTimeout(this.readTimer);
    interrupt = true;
    RFIDInstance.endStep();
  }

  executeRead() {
    const promises = process.map(item => item.execute);
    return promises.reduce(
      (previousPromise, nextPromise, index, myPromises) => {
        return previousPromise
          .then(() => {
            if (!interrupt) {
              return new Promise((resolve) => {
                setTimeout(() => {
                  resolve(nextPromise());
                }, 200);
              });
            }

            return Promise.reject(new Error('主动中断操作'));
          })
          .catch((error) => {
            if (process[index].abort === '1') {
              this.stop();
            } else if (!interrupt) {
              return Promise.resolve();
            }
            myPromises.splice(1);
            return Promise.reject(error);
          });
      },
      Promise.resolve()
    );
  }

  openBroadcast() {
    // 开启手机蓝牙扫描
    nativeInterface.startBleScan();
    this.setState({
      broadcastModalVisible: true,
    });
    this.startReadGeo();
  }

  closeBroadcast() {
    // 关闭手机蓝牙扫描，清空数据
    nativeInterface.stopBleScan();
    this.stopReadGeo();
    this.props.store.reset();
  }

  handleShowDetail(data) {
    if (!data || data.list.length === 0) {
      Toast.fail('该地磁暂无检测数据');
      return;
    }

    this.setState({
      showDetail: true,
      selected: data,
    });
  }

  closeModal() {
    this.stopReadGeo();
    this.setState({
      broadcastModalVisible: false,
    });
  }

  render() {
    const { list, macList } = this.props.store;
    const { showDetail, selected, broadcastModalVisible } = this.state;
    list.sort((a, b) => {
      if (a.lastList.detectTime && !b.lastList.detectTime) {
        return -1;
      }
      if (!a.lastList.detectTime && b.lastList.detectTime) {
        return 1;
      }
      if (!a.lastList.detectTime && !b.lastList.detectTime) {
        return 0;
      }
      return new Date(b.lastList.detectTime.replace(/-/g, '/')) - new Date(a.lastList.detectTime.replace(/-/g, '/'));
    });
    const geoList = list.length > 0 ? (
      list.map(item => (
        <GeoBroadcastCard
          store={item}
          key={item.mac}
          onClick={() => this.handleShowDetail(item)}
        />
      ))
    ) : (
      <NoState text="列表为空" />
    );

    return (
      <div className="detect-page">
        <div className="detect-page-header">
          <Button type="primary" onClick={this.openBroadcast}>
            开启广播
          </Button>
          <Button type="danger" onClick={this.closeBroadcast}>
            关闭广播
          </Button>
          {showDetail ? (
            <a className="back-to-list" href="#" onClick={this.onBack}>
              返回列表
            </a>
          ) : (
            ''
          )}
        </div>
        <div className="detect-page-body">
          {showDetail && selected ? (
            <BroadcastDetail store={selected} />
          ) : (
            geoList
          )}
        </div>

        <BaseModal
          title="开启广播"
          visible={broadcastModalVisible}
          onCloseModal={this.closeModal}
          showFooter={false}
          showCloseIcon={false}
          className="broadcast-modal"
        >
          <div className="put-tip">请将读卡器放置到地磁上方</div>
          <MacList data={macList} />
          <div
            className="broadcast-modal-close-btn"
            style={{ textAlign: 'center' }}
          >
            <Button type="ghost" onClick={this.closeModal}>
              关闭
            </Button>
          </div>
        </BaseModal>
      </div>
    );
  }
}

export default observer(Detect);
